<template>
  <div style="position:relative;">
    <div class="civii-flexcarousel" ref="container">
      <div class="civii-flexcarousel-viewport"
        ref="viewport"
      >
        <div class="civii-flexcarousel-slide"
          v-for="(slide, i) in slides"
          :key="'flex-crsl'+i"
          :style="slideStyle"
        >
          <slot name="slide" v-bind:slide="slide" />
        </div>
      </div>
    </div>
    <div @click="lastSlide" class="civii-nav-left" :class="{first}">
      <i class="civii-icon-arrow-left"></i>
    </div>
    <div @click="nextSlide" class="civii-nav-right" :class="{last}">
      <i class="civii-icon-arrow-right"></i>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    slides: Array,
    height: Number,
    transitionTime: {
      type: Number,
      default: 350
    },
    draw: Boolean
  },
  data () {
    return {
      pages: null,
      frameWidth: null,
      scrollFinished: true,
      slideStyle: {
        width: '100%'
      },
      first: false,
      last: false
    }
  },
  watch: {
    draw () {
      this.resizeSlides()
    }
  },
  mounted () {
    this.$nextTick(function () {
      if (this.height) this.$refs.container.style.height = this.height + 'px'
      window.addEventListener('resize', this.resizeSlides)
      this.resizeSlides()
    })
  },
  methods: {
    setContainerScroll (scrollValue, finished) {
      this.$refs.container.scrollLeft = scrollValue
      if (finished) this.scrollFinished = true
    },
    transition (direction) {
      if (this.scrollFinished) {
        this.scrollFinished = false
        this.animateScroll(
          this.$refs.container.scrollLeft,
          this.frameWidth * direction,
          this.transitionTime,
          this.setContainerScroll
        )
      }
    },
    lastSlide () {
      this.transition(-1)
    },
    nextSlide () {
      this.transition(1)
    },
    updateFrameWidth () {
      this.pages = Math.round(this.$refs.viewport.scrollWidth / this.$refs.container.clientWidth)
      this.frameWidth = this.$refs.viewport.scrollWidth / this.pages
    },
    resizeSlides (event) {
      try {
        this.$refs.container.scrollLeft = 0
        this.slideStyle.width = this.$refs.container.clientWidth + 'px'
        this.frameWidth = this.$refs.container.clientWidth
        this.pages = Math.round(this.$refs.viewport.scrollWidth / this.$refs.container.clientWidth)
      } catch (e) {}
    },
    animateScroll (start, distance, duration, func) {
      let runtime = 0
      let oldTimestamp = performance.now()
      function step (newTimestamp) {
        runtime += newTimestamp - oldTimestamp
        let timeFraction = runtime / duration
        let t = Math.PI * timeFraction
        let x = (1 - Math.cos(t)) * 0.5 * distance
        if (duration >= runtime) {
          oldTimestamp = newTimestamp
          func(start + x)
          window.requestAnimationFrame(step)
        } else {
          func(start + distance, true)
        }
      }
      window.requestAnimationFrame(step)
    }
  },
  beforeDestroy () {
    this.$refs.container.removeEventListener('resize', this.resizeSlides)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/FlexCarousel/FlexCarousel.vue